import { useRef, useState } from "react";
import Header from "./Header";
import NewHeader from "./NewHeader";
import Footer from "./Footer";
import "./layout.css";

const HEADER_HEIGHT = 75;
const FOOTER_HEIGHT = 48;

const Layout = ({ children }) => {
  const mainRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);

  // const onScroll = () => {
  //   if (!mainRef.current) return;
  //   setScrolled(mainRef.current.scrollTop > 0);
  // };

  return (
    <div className="app-layout">
      {/* <Header /> */}
      <NewHeader />

      <main ref={mainRef} className="app-main">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
